import HttpService from '../baseHttp'



// 移库计划 Allot=Allocation
export const HttpAllotList = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/findByPage', { params: data })
export const HttpAllot = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/getOne', { params: data })
export const HttpAllotNo = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/getTranNo', { params: data })
export const HttpUpdateAllot = (data = {}, config) => HttpService.post('/api/v2/AmazonAllocation/saveOne', data)
export const HttpUpdateAllotStatus = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/changeStatus', { params: data })
export const HttpResendAllot = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/resend', { params: data })

export const HttpUpdateAllotShipping = (data = {}, config) => HttpService.post('/api/v2/AmazonShipping/saveAll', data)

// 根据erpsku获取库存信息
export const HttpInventoryData = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/findByErpSkuAndOrgWarehouseId', { params: data })
// 根据erpsku库存获取erpsku信息
export const HttpErpskuData = (data = {}, config) => HttpService.get('/api/v2/inventory/findByErpSkuLike', { params: data })
//Amazon发运明细
export const HttpAllotShipList = (data = {}, config) => HttpService.get('/api/v2/AmazonShipping/findByPage', { params: data })

// 点击取消原因
export const HttpTransferStatus = (data = {}, config) => HttpService.get('/api/v2/AmazonAllocation/changeStatus', { params: data })


